import React from 'react';
import { Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

interface BannerCountProps {
  active_index: number;
  total_count: number;
}

export const SelectedBannerCounter: React.FC<React.PropsWithChildren<BannerCountProps>> = ({
  active_index,
  total_count,
}) => {
  if (!total_count) {
    return null;
  }

  return (
    <Wrapper style={{ width: `${total_count * 23}px` }}>
      <Unit style={{ transform: `translateX(${active_index * 23}px)` }} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 56px;
  display: flex;
  z-index: 1;
  height: 2px;

  background: rgba(255, 255, 255, 0.3);

  @media screen and (min-width: 418px) {
    left: 60px;
    transform: translateX(0);
    bottom: 70px;
  }
`;

const Unit = styled(Text)`
  position: absolute;
  top: 0;
  left: 0;
  width: 23px;
  height: 2px;
  background: ${vars.color.staticWhite};
  transition: transform 0.2s ease-in-out;
`;
